import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillTransfer, faCircleCheck, faRotate, faRotateLeft, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
import logo from '../../../assets/img/reactlogo.png';
const today = new Date().toISOString().split('T')[0];
// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    backgroundColor: '#ffffff'
  },
  section: {
    marginBottom: 5
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5
  },
  headerText: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: "center"
  },
  image: {
    width: 100
  },
  provider: {
    height: 50
  },
  date: {
    fontSize: 12,
    textAlign: 'right'
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf'
  },
  tableRow: {
    flexDirection: "row"
  },
  tableColHeader: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0'
  },
  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: '#bfbfbf'
  },
  tableCellHeader: {
    margin: 6,
    fontSize: 11,
    fontWeight: "bold"
  },
  tableCell: {
    margin: 6,
    fontSize: 11
  },
  footerContainer: {
    marginTop: 20
  },
  companyMainText: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  companyText: {
    fontSize: 9
  },
  totalCost: {
    fontSize: 12,
    fontWeight: 'bold'
  },
});

function RemitanceReport() {
  const [currentDate, setCurrentDate] = useState('');
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userId, setUserId] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [data, setData] = useState(false);
  const [recordData, setRecordData] = useState(false);
  const [users, setUsers] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [singleTransectionRow, setSingleTransectionRow] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );

  const PrintPDF = () => (
    typeof window !== 'undefined' && (<Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.headerContainer}>
            <Image style={styles.image} src={logo} />
            <Text style={styles.headerText}>Transaction Summary</Text>
            {
              data && singleTransectionRow && singleTransectionRow.map(data => (
                data.key == "Provider" &&
                data.val

              ))
            }
          </View>
          <View>
            <Text style={styles.companyMainText}>Pargati online service PVT LTD, SCO 832, 2nd floor, Cabin no. 10, NAC Manimajra Chandigah</Text>
            <Text style={styles.companyText}>Office Working Days: Monday To Saturday</Text>
            <Text style={styles.companyText}>Timing: 10:00 AM To 6:00 PM</Text>
            <Text style={styles.companyText}>Help Line: 01724049681</Text>
          </View>
        </View>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Remittance Report</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Detail</Text>
            </View>
          </View>
          {
            data && singleTransectionRow && singleTransectionRow.map(data => (
              data.key != "Provider" && (
                <View style={styles.tableRow}>
                  <View style={styles.tableColHeader}>
                    <Text style={styles.tableCellHeader}>{data.key}:</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{data.val}</Text>
                  </View>
                </View>
              )
            ))
          }
        </View>
      </Page>
    </Document>)
  );
  const handleSearch = async (e) => {
    e.preventDefault();
    const { user_id, payment_mode, status, verified, transection_pin, start_date, end_date } = e.target;
    let rechargeData = {
      user_id: userId != false ? userId : "",
      payment_mode: payment_mode.value,
      status: status.value,
      transection_pin: transection_pin.value,
      start_date: start_date.value,
      end_date: end_date.value,
      verified: verified.value,
    };
    getData(rechargeData);
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      user_id: pageData.user_id,
      payment_mode: pageData.payment_mode,
      status: pageData.status,
      transection_pin: pageData.transection_pin,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
      verified: pageData.verified,
    };
    getData(rechargeData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/remitanceReport", requestData);
      const { status, data, records, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setRecordData(records);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const showDetail = (e, rowIndex) => {
    e.preventDefault();
    handleShow();
    let rowData = data.data[rowIndex];
    setSingleTransectionRow([
      { key: "TransactionPin", val: rowData.p_transaction_pin },
      { key: "Date", val: moment(rowData.created_at).format('MMM-DD-YYYY, hh:mm:ss A') },
      { key: "PaymentMode", val: rowData.payment_mode },
      { key: "Sender(Mobile)", val: rowData?.sender?.name + "(" + rowData?.sender?.mobile + ")" },
      { key: "Sender City", val: rowData?.sender?.city },
      { key: "Receiver(Mobile)", val: rowData?.receiver?.receiver + "(" + rowData?.receiver?.receiver_mobile + ")" },
      { key: "Receiver Address", val: rowData?.receiver?.receiver_address },
      { key: "Amount(₹)", val: rowData.collected_amount },
      { key: "Service Charges(₹)", val: rowData.service_charge },
      { key: "Transfer Amount", val: rowData.transfer_amount },
      { key: "Status", val: rowData.status },
    ]);
  };
  const VerifyTransaction = async (id, pin_number) => {
    try {
      //const response = await axios.post("/remittance/verify/transaction", { id, pin_number });
      const response = await axios.post("/prabhuRemittance/verifyTransaction", { id, pin_number });
      const { status, message } = response.data;
      if (status) {
        document.querySelector(".search-btn").click();
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const RefundTransaction = async (amount, pin_number, transaction_id, user_id) => {
    try {
      let reqData = {
        amount,
        pin_number,
        transaction_id,
        user_id
      };
      const response = await axios.post("/remit-wallet/refund/amount", reqData);
      const { status, message } = response.data;
      if (status) {
        document.querySelector(".search-btn").click();
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const ReloadTransaction = async (partnerId) => {
    try {
      //const response = await axios.post("/remittance/search/transaction", { partnerId });
      const response = await axios.post("/prabhuRemittance/searchTransaction", { partnerId });
      const { status, message } = response.data;
      if (status) {
        document.querySelector(".search-btn").click();
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const ReloadAllTransaction = async () => {
    try {
      const response = await axios.post("/prabhuRemittance/searchTransactionAll");
      const { status, message } = response.data;
      if (status) {
        document.querySelector(".search-btn").click();
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const GeneratePDF = async (e, id) => {
    e.preventDefault();
    try {
      const response = await axios.post("/generate/remittPdf", { id });
      const { status, file } = response.data;
      if (status) {
        window.open(file, '_blank');
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const MakeRefund = async (e, partnerId) => {
    e.preventDefault();
    try {
      const response = await axios.post("/prabhuRemittance/makeRefund", { partnerId });
      const { status, message } = response.data;
      toast(message);
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const getData1 = async () => {
    try {
      const response = await axios.get("/get/all/users");
      const { status, users } = response.data;
      if (status) {
        setUsers(users);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    //getData1();
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setCurrentDate(today);
  }, []);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserId("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions(false);
      setLoading(false);
    });
  }, [query]);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Transfer Search</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />
                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserId(item._id);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label>Payment Mode</label>
                    <select class="form-control" name="payment_mode">
                      <option value="">--Select--</option>
                      <option value="Account Deposit">Account Deposit</option>
                      <option value="Cash Payment">Cash Payment</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>Status</label>
                    <select class="form-control" name="status">
                      <option value="">--Select--</option>
                      <option value="Paid">Paid</option>
                      <option value="Post">Post</option>
                      <option value="Compliance">Compilance</option>
                      <option value="Cancelled">Cancel</option>
                      <option value="Refunded">Refund</option>
                      <option value="Un-Paid">Unpaid</option>
                      <option value="pending">Pending</option>
                      <option value="Un-Claimed">Unclaimed</option>
                      <option value="Hold">Payment Hold</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>Transection Pin</label>
                    <input class="form-control" type="text" name="transection_pin" />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>Verified</label>
                    <select class="form-control" name="verified">
                      <option value="">All</option>
                      <option value="pending">Pending</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>From Date</label>
                    <input class="form-control" type="date" name="start_date" value={currentDate} max={today} onChange={(e) => setCurrentDate(e.target.value)} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Remitance History
                    </h4>
                    <div className="row">
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Amount Sent</strong></label>
                        <div>NPR {(recordData?.totalAmountSent * 1.6).toFixed(2)}(₹ {(recordData?.totalAmountSent).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Service Charge</strong></label>
                        <div>NPR {(recordData?.serviceRecharges * 1.6).toFixed(2)}(₹ {(recordData?.serviceRecharges).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total</strong></label>
                        <div>NPR {(recordData?.total * 1.6).toFixed(2)}(₹ {(recordData?.total).toFixed(2)})</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Remittance</strong></label>
                        <div>{recordData?.totalRemittance}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Refresh Records</strong></label>
                        <div><Link onClick={ReloadAllTransaction}><FontAwesomeIcon icon={faRotate} className="refreshRecords" title="Reload" /></Link></div>
                      </div>
                    </div>
                    <DataTable
                      value={data.data}
                      size="small"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="mobile"
                        header="User(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.user_id?.name}<br />({rowData?.user_id?.mobile})</span>}
                      />
                      <Column
                        field="p_transaction_pin"
                        header="TransactionPin"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="TransactionPin"><a href="javascript:void(0);" onClick={(e) => showDetail(e, rowIndex)}>{rowData.p_transaction_pin}</a></span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="payment_mode"
                        header="Payment Mode"
                        sortable
                        body={(rowData) => <span data-label="PaymentMode">{rowData?.payment_mode}</span>}
                      />
                      <Column
                        field="mobile"
                        header="Sender(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.sender?.name}<br />({rowData?.sender?.mobile})</span>}
                      />
                      <Column
                        field="city"
                        header="Sender City"
                        sortable
                        body={(rowData) => <span data-label="SenderCity">{rowData?.sender?.city}</span>}
                      />
                      <Column
                        field="mobile"
                        header="Receiver(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="Mobile">{rowData?.receiver?.receiver}<br />({rowData?.receiver?.receiver_mobile})</span>}
                      />
                      <Column
                        field="receiver_address"
                        header="Receiver Address"
                        sortable
                        body={(rowData) => <span data-label="ReceiverAddress">{rowData?.receiver?.receiver_address}</span>}
                      />
                      <Column
                        field="collected_amount"
                        header="Amount(₹)"
                        sortable
                        body={(rowData) => <span data-label="Amount">{rowData.collected_amount}</span>}
                      />
                      <Column
                        field="service_charge"
                        header="Service Charges(₹)"
                        sortable
                        body={(rowData) => <span data-label="ServiceCharges">{rowData.service_charge}</span>}
                      />
                      <Column
                        field="transfer_amount"
                        header="Transfer Amount"
                        sortable
                        body={(rowData) => <span data-label="Transfer Amount">{rowData.transfer_amount}</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{rowData.status}</span>}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData) => (
                            <span data-label="Action">
                              {rowData?.verified == "pending" && (<Link onClick={(e) => VerifyTransaction(rowData?._id, rowData?.p_transaction_pin)}><FontAwesomeIcon icon={faCircleCheck} className="successIcon" title="Verify" /></Link>)}
                              <Link onClick={(e) => ReloadTransaction(rowData?.p_transaction_pin)}><FontAwesomeIcon icon={faRotate} className="successIcon" title="Reload" /></Link>
                              <Link onClick={(e) => GeneratePDF(e, rowData?._id)}><FontAwesomeIcon icon={faFilePdf} className="successIcon" title="PDF" /></Link>
                              {["Cancelled", "Refunded"].includes(rowData?.status) && rowData?.refund_status != "refunded" && new Date(rowData?.created_at).getFullYear() >= 2026 && (<Link onClick={(e) => RefundTransaction(rowData?.collected_amount, rowData?.p_transaction_pin, rowData?._id, rowData?.user_id?._id)}><FontAwesomeIcon icon={faMoneyBillTransfer} className="successIcon" title="Refund" /></Link>)}
                              <Link onClick={(e) => MakeRefund(e, rowData?.p_transaction_pin)}><FontAwesomeIcon icon={faRotateLeft} className="successIcon" title="RotateLeft" /></Link>
                              {/* {rowData?.verified == "pending" && (<button className="btn btn-primary" onClick={(e) => VerifyTransaction(rowData?._id, rowData?.p_transaction_pin)}>Verify</button>)}
                              <button className="btn btn-primary" onClick={(e) => ReloadTransaction(rowData?.p_transaction_pin)}>Reload</button>
                              <button className="btn btn-primary" onClick={(e) => GeneratePDF(e, rowData?._id)}>PDF</button>
                              {rowData?.status == "Cancelled" && rowData?.refund_status != "refunded" && (<button className="btn btn-primary" onClick={(e) => RefundTransaction(rowData?.collected_amount, rowData?.p_transaction_pin, rowData?._id, rowData?.user_id?._id)}>Refund</button>)} */}
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={showModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Transection Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {
              data && singleTransectionRow && (
                <ul className="showData">
                  {
                    singleTransectionRow.map(data => (
                      data.key != "Provider" && (
                        <li>
                          <strong>{data.key}:</strong>
                          <div>{data.val}</div>
                        </li>
                      )
                    ))
                  }
                </ul>
              )
            }
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {typeof window !== 'undefined' && showModal && (
            <PDFDownloadLink className="btn btn-primary" document={<PrintPDF />} fileName="mypdf.pdf">
              {({ blob, url, loading, error }) =>
                loading ? 'Loading document...' : 'Print'
              }
            </PDFDownloadLink>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default RemitanceReport;
